//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';
import { ClientConfig, AuthorizedClientBase } from "msg-swagger";
import { BaseFilter } from "msg-spaces-client-web/dist/v2.0";

export class DataClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    tracks(mmsi: number, reduceDistance: number | undefined, reduceTime: number | undefined, filter: DebugFilter | undefined): Promise<DataResultDto> {
        let url_ = this.baseUrl + "/api/Data/{mmsi}?";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{mmsi}", encodeURIComponent("" + mmsi));
        if (reduceDistance === null)
            throw new Error("The parameter 'reduceDistance' cannot be null.");
        else if (reduceDistance !== undefined)
            url_ += "reduceDistance=" + encodeURIComponent("" + reduceDistance) + "&";
        if (reduceTime === null)
            throw new Error("The parameter 'reduceTime' cannot be null.");
        else if (reduceTime !== undefined)
            url_ += "reduceTime=" + encodeURIComponent("" + reduceTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTracks(_response);
        });
    }

    protected processTracks(response: Response): Promise<DataResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataResultDto>(null as any);
    }

    upload(reduceDistance: number | undefined, reduceTime: number | undefined, mmsi: number | null | undefined, upload: FileParameter | null | undefined, filter_Tracks: string[] | null | undefined, filter_PriorityLevel: number | null | undefined, filter_From: moment.Moment | null | undefined, filter_To: moment.Moment | null | undefined): Promise<DataResultDto> {
        let url_ = this.baseUrl + "/api/Data/upload?";
        if (reduceDistance === null)
            throw new Error("The parameter 'reduceDistance' cannot be null.");
        else if (reduceDistance !== undefined)
            url_ += "reduceDistance=" + encodeURIComponent("" + reduceDistance) + "&";
        if (reduceTime === null)
            throw new Error("The parameter 'reduceTime' cannot be null.");
        else if (reduceTime !== undefined)
            url_ += "reduceTime=" + encodeURIComponent("" + reduceTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (mmsi !== null && mmsi !== undefined)
            content_.append("Mmsi", mmsi.toString());
        if (upload !== null && upload !== undefined)
            content_.append("Upload", upload.data, upload.fileName ? upload.fileName : "Upload");
        if (filter_Tracks !== null && filter_Tracks !== undefined)
            filter_Tracks.forEach(item_ => content_.append("Filter.Tracks", item_.toString()));
        if (filter_PriorityLevel !== null && filter_PriorityLevel !== undefined)
            content_.append("Filter.PriorityLevel", filter_PriorityLevel.toString());
        if (filter_From !== null && filter_From !== undefined)
            content_.append("Filter.From", filter_From.toJSON());
        if (filter_To !== null && filter_To !== undefined)
            content_.append("Filter.To", filter_To.toJSON());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<DataResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataResultDto>(null as any);
    }

    oreFileDownload(mmsi: number, filter: DebugFilter | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Data/download/{mmsi}.ore";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{mmsi}", encodeURIComponent("" + mmsi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOreFileDownload(_response);
        });
    }

    protected processOreFileDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    firewallReportFileDownload(mmsi: number, filter: DebugFilter | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Data/download/{mmsi}.fwr";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{mmsi}", encodeURIComponent("" + mmsi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFirewallReportFileDownload(_response);
        });
    }

    protected processFirewallReportFileDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logMessages(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Data/log-messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogMessages(_response);
        });
    }

    protected processLogMessages(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class OverrideClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getALL(): Promise<FirewallPriorityOverride[]> {
        let url_ = this.baseUrl + "/api/Override/getall";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetALL(_response);
        });
    }

    protected processGetALL(response: Response): Promise<FirewallPriorityOverride[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirewallPriorityOverride.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FirewallPriorityOverride[]>(null as any);
    }

    addOrUpdate(firewallPriorityOverride: FirewallPriorityOverride): Promise<void> {
        let url_ = this.baseUrl + "/api/Override/addorupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(firewallPriorityOverride);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddOrUpdate(_response);
        });
    }

    protected processAddOrUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    remove(mmsi: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Override/remove?";
        if (mmsi === null)
            throw new Error("The parameter 'mmsi' cannot be null.");
        else if (mmsi !== undefined)
            url_ += "mmsi=" + encodeURIComponent("" + mmsi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    index(): Promise<FirewallInfo[]> {
        let url_ = this.baseUrl + "/api/Statistics/index";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FirewallInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirewallInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FirewallInfo[]>(null as any);
    }

    vessels(query: FilteredDataRequest): Promise<PageResultOfVesselInfoDto> {
        let url_ = this.baseUrl + "/api/Statistics/vessels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVessels(_response);
        });
    }

    protected processVessels(response: Response): Promise<PageResultOfVesselInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PageResultOfVesselInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PageResultOfVesselInfoDto>(null as any);
    }

    vessel(mmsi: number): Promise<VesselInfoDto> {
        let url_ = this.baseUrl + "/api/Statistics/vessel/{mmsi}";
        if (mmsi === undefined || mmsi === null)
            throw new Error("The parameter 'mmsi' must be defined.");
        url_ = url_.replace("{mmsi}", encodeURIComponent("" + mmsi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVessel(_response);
        });
    }

    protected processVessel(response: Response): Promise<VesselInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VesselInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VesselInfoDto>(null as any);
    }
}

export class TokenClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<TokenInfo> {
        let url_ = this.baseUrl + "/api/Token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TokenInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TokenInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TokenInfo>(null as any);
    }
}

export class WebClientSettingsClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<WebClientSettings> {
        let url_ = this.baseUrl + "/api/WebClientSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<WebClientSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WebClientSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebClientSettings>(null as any);
    }
}

export class PermissionClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    isAuthorized(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Permission/Authorized";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsAuthorized(_response);
        });
    }

    protected processIsAuthorized(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    hasPermission(permission: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Permission/HasPermission?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasPermission(_response);
        });
    }

    protected processHasPermission(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPermissions(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Permission/GetPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class DataResultDto implements IDataResultDto {
    mmsi!: number;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    results!: TrackDto[];
    count!: number;
    errors!: number;
    skipped!: number;
    skippedMmsis!: number[];

    constructor(data?: IDataResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.results = [];
            this.skippedMmsis = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mmsi = _data["mmsi"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(TrackDto.fromJS(item));
            }
            this.count = _data["count"];
            this.errors = _data["errors"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["skippedMmsis"])) {
                this.skippedMmsis = [] as any;
                for (let item of _data["skippedMmsis"])
                    this.skippedMmsis!.push(item);
            }
        }
    }

    static fromJS(data: any): DataResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mmsi"] = this.mmsi;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["errors"] = this.errors;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.skippedMmsis)) {
            data["skippedMmsis"] = [];
            for (let item of this.skippedMmsis)
                data["skippedMmsis"].push(item);
        }
        return data;
    }
}

export interface IDataResultDto {
    mmsi: number;
    startTime?: moment.Moment | undefined;
    endTime?: moment.Moment | undefined;
    results: TrackDto[];
    count: number;
    errors: number;
    skipped: number;
    skippedMmsis: number[];
}

export class TrackDto implements ITrackDto {
    id!: string;
    description?: string | undefined;
    priority!: number;
    isRemoved!: boolean;
    staticChanges!: number;
    staticMatched!: number;
    hasReport!: boolean;
    hasSeawebMatch!: boolean;
    pointCount!: number;
    outlierCount!: number;
    name?: string | undefined;
    imo?: string | undefined;
    callSign?: string | undefined;
    lengthStern?: number | undefined;
    lengthBow?: number | undefined;
    widthStarboard?: number | undefined;
    widthPort?: number | undefined;
    start?: moment.Moment | undefined;
    end?: moment.Moment | undefined;
    points?: PointDto[] | undefined;

    constructor(data?: ITrackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.priority = _data["priority"];
            this.isRemoved = _data["isRemoved"];
            this.staticChanges = _data["staticChanges"];
            this.staticMatched = _data["staticMatched"];
            this.hasReport = _data["hasReport"];
            this.hasSeawebMatch = _data["hasSeawebMatch"];
            this.pointCount = _data["pointCount"];
            this.outlierCount = _data["outlierCount"];
            this.name = _data["name"];
            this.imo = _data["imo"];
            this.callSign = _data["callSign"];
            this.lengthStern = _data["lengthStern"];
            this.lengthBow = _data["lengthBow"];
            this.widthStarboard = _data["widthStarboard"];
            this.widthPort = _data["widthPort"];
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(PointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrackDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["priority"] = this.priority;
        data["isRemoved"] = this.isRemoved;
        data["staticChanges"] = this.staticChanges;
        data["staticMatched"] = this.staticMatched;
        data["hasReport"] = this.hasReport;
        data["hasSeawebMatch"] = this.hasSeawebMatch;
        data["pointCount"] = this.pointCount;
        data["outlierCount"] = this.outlierCount;
        data["name"] = this.name;
        data["imo"] = this.imo;
        data["callSign"] = this.callSign;
        data["lengthStern"] = this.lengthStern;
        data["lengthBow"] = this.lengthBow;
        data["widthStarboard"] = this.widthStarboard;
        data["widthPort"] = this.widthPort;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrackDto {
    id: string;
    description?: string | undefined;
    priority: number;
    isRemoved: boolean;
    staticChanges: number;
    staticMatched: number;
    hasReport: boolean;
    hasSeawebMatch: boolean;
    pointCount: number;
    outlierCount: number;
    name?: string | undefined;
    imo?: string | undefined;
    callSign?: string | undefined;
    lengthStern?: number | undefined;
    lengthBow?: number | undefined;
    widthStarboard?: number | undefined;
    widthPort?: number | undefined;
    start?: moment.Moment | undefined;
    end?: moment.Moment | undefined;
    points?: PointDto[] | undefined;
}

export class PointDto implements IPointDto {
    id!: string;
    index!: number;
    match?: number | undefined;
    lat!: number;
    lon!: number;
    cog?: number | undefined;
    time!: moment.Moment;
    log?: { [key: string]: string; } | undefined;
    isTrackB!: boolean;
    isOutlier!: boolean;
    isLongRange!: boolean;
    mark!: boolean;

    constructor(data?: IPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.index = _data["index"];
            this.match = _data["match"];
            this.lat = _data["lat"];
            this.lon = _data["lon"];
            this.cog = _data["cog"];
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            if (_data["log"]) {
                this.log = {} as any;
                for (let key in _data["log"]) {
                    if (_data["log"].hasOwnProperty(key))
                        (<any>this.log)![key] = _data["log"][key];
                }
            }
            this.isTrackB = _data["isTrackB"];
            this.isOutlier = _data["isOutlier"];
            this.isLongRange = _data["isLongRange"];
            this.mark = _data["mark"];
        }
    }

    static fromJS(data: any): PointDto {
        data = typeof data === 'object' ? data : {};
        let result = new PointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["index"] = this.index;
        data["match"] = this.match;
        data["lat"] = this.lat;
        data["lon"] = this.lon;
        data["cog"] = this.cog;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        if (this.log) {
            data["log"] = {};
            for (let key in this.log) {
                if (this.log.hasOwnProperty(key))
                    (<any>data["log"])[key] = (<any>this.log)[key];
            }
        }
        data["isTrackB"] = this.isTrackB;
        data["isOutlier"] = this.isOutlier;
        data["isLongRange"] = this.isLongRange;
        data["mark"] = this.mark;
        return data;
    }
}

export interface IPointDto {
    id: string;
    index: number;
    match?: number | undefined;
    lat: number;
    lon: number;
    cog?: number | undefined;
    time: moment.Moment;
    log?: { [key: string]: string; } | undefined;
    isTrackB: boolean;
    isOutlier: boolean;
    isLongRange: boolean;
    mark: boolean;
}

export class DebugFilter implements IDebugFilter {
    tracks?: string[] | undefined;
    priorityLevel?: number | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;

    constructor(data?: IDebugFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tracks"])) {
                this.tracks = [] as any;
                for (let item of _data["tracks"])
                    this.tracks!.push(item);
            }
            this.priorityLevel = _data["priorityLevel"];
            this.from = _data["from"] ? moment(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? moment(_data["to"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DebugFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DebugFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tracks)) {
            data["tracks"] = [];
            for (let item of this.tracks)
                data["tracks"].push(item);
        }
        data["priorityLevel"] = this.priorityLevel;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDebugFilter {
    tracks?: string[] | undefined;
    priorityLevel?: number | undefined;
    from?: moment.Moment | undefined;
    to?: moment.Moment | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class FirewallPriorityOverride implements IFirewallPriorityOverride {
    mmsi!: number;
    isActive!: boolean;
    imoNumber?: number | undefined;
    name?: string | undefined;
    callSign?: string | undefined;
    lengthBow?: number | undefined;
    lengthStern?: number | undefined;
    widthPort?: number | undefined;
    widthStarboard?: number | undefined;

    constructor(data?: IFirewallPriorityOverride) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isActive = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mmsi = _data["mmsi"];
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : true;
            this.imoNumber = _data["imoNumber"];
            this.name = _data["name"];
            this.callSign = _data["callSign"];
            this.lengthBow = _data["lengthBow"];
            this.lengthStern = _data["lengthStern"];
            this.widthPort = _data["widthPort"];
            this.widthStarboard = _data["widthStarboard"];
        }
    }

    static fromJS(data: any): FirewallPriorityOverride {
        data = typeof data === 'object' ? data : {};
        let result = new FirewallPriorityOverride();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mmsi"] = this.mmsi;
        data["isActive"] = this.isActive;
        data["imoNumber"] = this.imoNumber;
        data["name"] = this.name;
        data["callSign"] = this.callSign;
        data["lengthBow"] = this.lengthBow;
        data["lengthStern"] = this.lengthStern;
        data["widthPort"] = this.widthPort;
        data["widthStarboard"] = this.widthStarboard;
        return data;
    }
}

export interface IFirewallPriorityOverride {
    mmsi: number;
    isActive: boolean;
    imoNumber?: number | undefined;
    name?: string | undefined;
    callSign?: string | undefined;
    lengthBow?: number | undefined;
    lengthStern?: number | undefined;
    widthPort?: number | undefined;
    widthStarboard?: number | undefined;
}

export class FirewallInfo implements IFirewallInfo {
    name!: string;
    metrics!: any[];

    constructor(data?: IFirewallInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.metrics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["metrics"])) {
                this.metrics = [] as any;
                for (let item of _data["metrics"])
                    this.metrics!.push(item);
            }
        }
    }

    static fromJS(data: any): FirewallInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FirewallInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.metrics)) {
            data["metrics"] = [];
            for (let item of this.metrics)
                data["metrics"].push(item);
        }
        return data;
    }
}

export interface IFirewallInfo {
    name: string;
    metrics: any[];
}

export class PageResultOfVesselInfoDto implements IPageResultOfVesselInfoDto {
    result!: VesselInfoDto[];
    totalItemCount!: number;

    constructor(data?: IPageResultOfVesselInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(VesselInfoDto.fromJS(item));
            }
            this.totalItemCount = _data["totalItemCount"];
        }
    }

    static fromJS(data: any): PageResultOfVesselInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageResultOfVesselInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["totalItemCount"] = this.totalItemCount;
        return data;
    }
}

export interface IPageResultOfVesselInfoDto {
    result: VesselInfoDto[];
    totalItemCount: number;
}

export class VesselInfoDto implements IVesselInfoDto {
    mmsi!: number;
    isValidMmsi!: boolean;
    description?: string | undefined;
    largeTracks!: number;
    tracksWithStatic!: number;
    totalTracks!: number;
    staticReceived!: number;
    staticChanges!: number;
    staticMatched!: number;
    maxPointCount!: number;
    totalPointCount!: number;
    sameCount!: number;
    uniqueCount!: number;
    quality!: number;
    overlap!: number;
    concurrency!: number;

    constructor(data?: IVesselInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mmsi = _data["mmsi"];
            this.isValidMmsi = _data["isValidMmsi"];
            this.description = _data["description"];
            this.largeTracks = _data["largeTracks"];
            this.tracksWithStatic = _data["tracksWithStatic"];
            this.totalTracks = _data["totalTracks"];
            this.staticReceived = _data["staticReceived"];
            this.staticChanges = _data["staticChanges"];
            this.staticMatched = _data["staticMatched"];
            this.maxPointCount = _data["maxPointCount"];
            this.totalPointCount = _data["totalPointCount"];
            this.sameCount = _data["sameCount"];
            this.uniqueCount = _data["uniqueCount"];
            this.quality = _data["quality"];
            this.overlap = _data["overlap"];
            this.concurrency = _data["concurrency"];
        }
    }

    static fromJS(data: any): VesselInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VesselInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mmsi"] = this.mmsi;
        data["isValidMmsi"] = this.isValidMmsi;
        data["description"] = this.description;
        data["largeTracks"] = this.largeTracks;
        data["tracksWithStatic"] = this.tracksWithStatic;
        data["totalTracks"] = this.totalTracks;
        data["staticReceived"] = this.staticReceived;
        data["staticChanges"] = this.staticChanges;
        data["staticMatched"] = this.staticMatched;
        data["maxPointCount"] = this.maxPointCount;
        data["totalPointCount"] = this.totalPointCount;
        data["sameCount"] = this.sameCount;
        data["uniqueCount"] = this.uniqueCount;
        data["quality"] = this.quality;
        data["overlap"] = this.overlap;
        data["concurrency"] = this.concurrency;
        return data;
    }
}

export interface IVesselInfoDto {
    mmsi: number;
    isValidMmsi: boolean;
    description?: string | undefined;
    largeTracks: number;
    tracksWithStatic: number;
    totalTracks: number;
    staticReceived: number;
    staticChanges: number;
    staticMatched: number;
    maxPointCount: number;
    totalPointCount: number;
    sameCount: number;
    uniqueCount: number;
    quality: number;
    overlap: number;
    concurrency: number;
}

export class FilteredDataRequest implements IFilteredDataRequest {
    filters?: BaseFilter[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    sort?: string | undefined;
    sortDirection?: string | undefined;

    constructor(data?: IFilteredDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(BaseFilter.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.sort = _data["sort"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): FilteredDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["sort"] = this.sort;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IFilteredDataRequest {
    filters?: BaseFilter[] | undefined;
    skip?: number | undefined;
    take?: number | undefined;
    sort?: string | undefined;
    sortDirection?: string | undefined;
}

export enum PropertyType {
    Int = 0,
    IntSet = 1,
    Double = 2,
    DoubleSet = 3,
    String = 4,
    StringSet = 5,
    Boolean = 6,
    BooleanSet = 7,
    DateTime = 8,
    DateTimeSet = 9,
    Guid = 10,
    GuidSet = 11,
}

export class TokenInfo implements ITokenInfo {
    token!: string;
    age!: number;

    constructor(data?: ITokenInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.age = _data["age"];
        }
    }

    static fromJS(data: any): TokenInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TokenInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["age"] = this.age;
        return data;
    }
}

export interface ITokenInfo {
    token: string;
    age: number;
}

export class WebClientSettings implements IWebClientSettings {
    chartLayer!: LayerSettings;
    osmLayer!: LayerSettings;
    satelliteLayer!: LayerSettings;
    useTestCases!: boolean;
    maxAgeStorageDays!: number;

    constructor(data?: IWebClientSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chartLayer = new LayerSettings();
            this.osmLayer = new LayerSettings();
            this.satelliteLayer = new LayerSettings();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartLayer = _data["chartLayer"] ? LayerSettings.fromJS(_data["chartLayer"]) : new LayerSettings();
            this.osmLayer = _data["osmLayer"] ? LayerSettings.fromJS(_data["osmLayer"]) : new LayerSettings();
            this.satelliteLayer = _data["satelliteLayer"] ? LayerSettings.fromJS(_data["satelliteLayer"]) : new LayerSettings();
            this.useTestCases = _data["useTestCases"];
            this.maxAgeStorageDays = _data["maxAgeStorageDays"];
        }
    }

    static fromJS(data: any): WebClientSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WebClientSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartLayer"] = this.chartLayer ? this.chartLayer.toJSON() : <any>undefined;
        data["osmLayer"] = this.osmLayer ? this.osmLayer.toJSON() : <any>undefined;
        data["satelliteLayer"] = this.satelliteLayer ? this.satelliteLayer.toJSON() : <any>undefined;
        data["useTestCases"] = this.useTestCases;
        data["maxAgeStorageDays"] = this.maxAgeStorageDays;
        return data;
    }
}

export interface IWebClientSettings {
    chartLayer: LayerSettings;
    osmLayer: LayerSettings;
    satelliteLayer: LayerSettings;
    useTestCases: boolean;
    maxAgeStorageDays: number;
}

export abstract class SettingsBase implements ISettingsBase {
    instance?: string | undefined;

    constructor(data?: ISettingsBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): SettingsBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SettingsBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instance"] = this.instance;
        return data;
    }
}

export interface ISettingsBase {
    instance?: string | undefined;
}

export class LayerSettings extends SettingsBase implements ILayerSettings {
    minZoom?: number;
    maxZoom?: number;
    url?: string | undefined;
    attributions?: string | undefined;
    wmsLayers?: string | undefined;

    constructor(data?: ILayerSettings) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minZoom = _data["minZoom"];
            this.maxZoom = _data["maxZoom"];
            this.url = _data["url"];
            this.attributions = _data["attributions"];
            this.wmsLayers = _data["wmsLayers"];
        }
    }

    static fromJS(data: any): LayerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new LayerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minZoom"] = this.minZoom;
        data["maxZoom"] = this.maxZoom;
        data["url"] = this.url;
        data["attributions"] = this.attributions;
        data["wmsLayers"] = this.wmsLayers;
        super.toJSON(data);
        return data;
    }
}

export interface ILayerSettings extends ISettingsBase {
    minZoom?: number;
    maxZoom?: number;
    url?: string | undefined;
    attributions?: string | undefined;
    wmsLayers?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}